import {submitBrief as submit} from '../services/brief';

export const actions = {
  COMPLETED_STEPS: 'PROGRESS::COMPLETED_STEPS',
  COMPLETE_SERVICE_SELECTION: 'PROGRESS::COMPLETE_SERVICE_SELECTION',
  RESET_SERVICE_SELECTION: 'PROGRESS::RESET_SERVICE_SELECTION',
  SUBMIT_PENDING: 'PROGRESS::SUBMIT_PENDING',
  SUBMIT_FULFILLED: 'PROGRESS::SUBMIT_FULFILLED',
  SUBMIT_REJECTED: 'PROGRESS::SUBMIT_REJECTED',
  ERROR: 'PROGRESS::ERROR',
};

export function submitBrief(brief) {
  return dispatch => {
    dispatch({type: actions.SUBMIT_PENDING});

    return submit(brief)
      .then((response = {}) => {
        dispatch({
          type: actions.SUBMIT_FULFILLED,
          payload: {
            brief: response.brief,
          },
        });
        return response.brief;
      })
      .catch(err => {
        const error =
          err.status === 429
            ? {
                title: 'You’ve reached your daily job submission limit',
                message:
                  'Wait 24 hours and try again if you want to send another job.',
                ctaText: 'View Jobs',
                ctaUrl: '/services_marketplace/job_requests',
              }
            : {
                title: 'Failed to submit request',
                message: err.message,
              };

        dispatch({
          type: actions.SUBMIT_REJECTED,
          payload: {error},
        });
      });
  };
}

export function resetServiceSelection(questionHandles = [], inputHandles = []) {
  return {
    type: actions.RESET_SERVICE_SELECTION,
    payload: {
      questionHandles,
      inputHandles,
    },
  };
}

export function setError(error) {
  return {
    type: actions.ERROR,
    payload: {
      error,
    },
  };
}
